<div id="adnReport" *ngIf="test && scoresParse" [class]="reportType == 'executive' ? 'executiveReportStyle': ''">
  <div class="bg-color-white shadow-lg color-primary body-m">
    <!-- Apartados que no se muestran para informe ejecutivo -->
    <ng-container *ngIf="reportType != 'executive'">
      <!-- Portada -->
      <ct-cover-page-report [colors]="colors" [reportType]="reportType" [test]="test" [currentDate]="currentDate"></ct-cover-page-report>

      <!-- Índice -->
      <ct-index-report [colors]="colors" [reportType]="reportType" [test]="test" [isMD]="false" [dinamicPageNumber1]="6 + utilsService.roundUp(scoresParseStrenghtsFiltered.length / 2)" [dinamicPageNumber2]="6 + utilsService.roundUp(scoresParse.length / 2)"></ct-index-report>

      <!-- Header -->
      <div id="header" class="d-flex justify-content-between color-tertiary body-s mar-t-3">
          <div>{{ (test.candidate?.name)
            ? (test.candidate | initials)
            : test.candidate.randstadCandidate }} | {{ (test.invitationId != 0 ? test.invitationId : test.externalId) }} | {{testModel + '/02/' + (reportType === 'candidate' ? '': (test.adjustment ? 'CA/': 'SA/')) + 'SP'}}</div>
          <div>{{ currentDate | date:'dd/MM/yyyy' }}</div>
      </div>

      <!-- Introducción -->
      <div class="page">
        <div id="intro">
          <h1 class="color-tertiary title-xl mar-b-3">{{ 'COMMON.INTRODUCTION' | translate }}</h1>
          <div>
            <p [innerHtml]="'REPORT.CT.ADN.' + reportType.toUpperCase() + '.INTRODUCTION.1' | translate"></p>
            <p [innerHtml]="'REPORT.CT.ADN.' + reportType.toUpperCase() + '.INTRODUCTION.2' | translate"></p>
            <p [innerHtml]="'REPORT.CT.ADN.' + reportType.toUpperCase() + '.INTRODUCTION.3' | translate"></p>
            <p [innerHtml]="'REPORT.CT.ADN.' + reportType.toUpperCase() + '.INTRODUCTION.4' | translate"></p>
            <p [innerHtml]="'REPORT.CT.ADN.' + reportType.toUpperCase() + '.INTRODUCTION.5' | translate:{ initials: (test.candidate?.name ? (test.candidate | initials) : test.candidate.randstadCandidate) }"></p>
            <p [innerHtml]="'REPORT.CT.ADN.' + reportType.toUpperCase() + '.INTRODUCTION.6' | translate:{ initials: (test.candidate?.name ? (test.candidate | initials) : test.candidate.randstadCandidate) }"></p>
            <p [innerHtml]="'REPORT.CT.ADN.' + reportType.toUpperCase() + '.INTRODUCTION.7' | translate:{ initials: (test.candidate?.name ? (test.candidate | initials) : test.candidate.randstadCandidate) }"></p>
            <p [innerHtml]="'REPORT.CT.ADN.' + reportType.toUpperCase() + '.INTRODUCTION.8' | translate:{ initials: (test.candidate?.name ? (test.candidate | initials) : test.candidate.randstadCandidate) }"></p>
            <p [innerHtml]="'REPORT.CT.ADN.' + reportType.toUpperCase() + '.INTRODUCTION.9' | translate"></p>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Gráfico ADN -->
    <div [class]="reportType != 'executive' ? 'page' : 'page-no-break'">
      <div>
        <h1 class="color-tertiary title-xl mar-b-3" *ngIf="reportType !== 'executive'">{{ ('REPORT.CT.ADN.GENERAL.RESULTSCHART.'+ (test.adjustment ? 'ADJUSTMENT' : 'NOTADJUSTMENT') + '.TITLE') | translate }}</h1>
        <ng-container *ngIf="reportType === 'consultant' || reportType === 'client'">
          <div class="row adjustmentPercentRow" *ngIf="test.adjustment">
            <div class="col-2 title-xxl color-tertiary">{{ test.adjustment + '%' }}</div>
            <div class="col-10 align-self-center" innerHTML="{{ 'REPORT.CT.ADN.GENERAL.RESULTSCHART.ADJUSTMENT.INTRODUCTION' | translate: { candidateName: (test.candidate?.name ? (test.candidate | initials) : test.candidate.randstadCandidate), idealProfileName: idealProfileName, percent: test.adjustment } }}"></div>
          </div>
        </ng-container>
        <div id="chartContainer">
          <div class="chart-legend-top" *ngIf="reportType === 'executive'">
              <ul>
                  <li class="external-area"><span>{{ 'ADNREPORT.SKILLS.TYPES.EXTERNAL_AREA' | translate }}</span></li>
                  <li><span class="color-tertiary">&#x25CF;</span> {{ 'ADNREPORT.SKILLS.TYPES.MANAGEMENT' | translate }}</li>
                  <li><span class="color-senary">&#x25CF;</span> {{ 'ADNREPORT.SKILLS.TYPES.SOCIAL' | translate }}</li>
              </ul>
              <ul>
                  <li class="internal-area"><span>{{ 'ADNREPORT.SKILLS.TYPES.INTERNAL_AREA' | translate }}</span></li>
                  <li><span class="color-secondary">&#x25CF;</span> {{ 'ADNREPORT.SKILLS.TYPES.INDIVIDUAL' | translate }}</li>
                  <li><span class="color-octonary">&#x25CF;</span> {{ 'ADNREPORT.SKILLS.TYPES.TASK' | translate }}</li>
              </ul>

              <ul>
                <li class="level-required-legend" *ngIf="test.adjustment">
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAFCAYAAACuNHcwAAAAAXNSR0IArs4c6QAAAFtJREFUKFNjZCACeAeG6zD8Z5z+n4HBhpGB4QgD4//MretXXiGklfHqjZv/CSmaNmMuw/0Hj+DKFBXkGLIykglpYyDK8NKKegyDujsaqWM42S4naD0DAwO5YQ4AMXgrlf/8ArwAAAAASUVORK5CYII=">
                    <div>{{ 'REPORT.CT.ADN.GENERAL.RESULTSCHART.CHART.LEGEND.REQUIRED_LEVEL' | translate }}</div>
                </li>
              </ul>
          </div>

          <div id="adnChart">
            <canvas baseChart id="chartScore" *ngIf="chartScoreOptions" style="width: 725px; margin: auto;"
              [data]="chartScoreData"
              [labels]="chartScoreLabels"
              [options]="chartScoreOptions"
              [plugins]="chartScorePlugins"
              type="pie">
            </canvas>

            <canvas baseChart id="chartAdjustment" *ngIf="chartAdjustmentOptions" style="width: 725px; margin: auto; margin-top: -725px; pointer-events: none;"
              [data]="chartAdjustmentData"
              [labels]="chartAdjustmentLabels"
              [options]="chartAdjustmentOptions"
              [plugins]="chartAdjustmentPlugins"
              type="radar">
            </canvas>

            <canvas baseChart id="chartScoreBase10" *ngIf="chartScoreBase10Options && reportType === 'consultant'" style="width: 725px; margin: auto; margin-top: -725px; pointer-events: none;"
              [data]="chartScoreBase10Data"
              [labels]="chartScoreBase10Labels"
              [options]="chartScoreBase10Options"
              [plugins]="chartScoreBase10Plugins"
              type="radar">
            </canvas>
          </div>

          <img id="adnChartImg" style="display: block; margin: auto; max-height: 600px;" [hidden]="reportType !== 'executive'">

          <div class="chart-legend-right d-none d-lg-block body-xs" *ngIf="reportType !== 'executive'">
            <div class="color-tertiary"><span>{{ 'ADNREPORT.SKILLS.TYPES.EXTERNAL_AREA' | translate }}</span></div>
            <div><div class="circle bg-color-tertiary"></div> {{ 'ADNREPORT.SKILLS.TYPES.MANAGEMENT' | translate }}</div>
            <div><div class="circle bg-color-senary"></div> {{ 'ADNREPORT.SKILLS.TYPES.SOCIAL' | translate }}</div>
            <hr>
            <div class="color-tertiary"><span>{{ 'ADNREPORT.SKILLS.TYPES.INTERNAL_AREA' | translate }}</span></div>
            <div><div class="circle bg-color-secondary"></div> {{ 'ADNREPORT.SKILLS.TYPES.INDIVIDUAL' | translate }}</div>
            <div><div class="circle bg-color-octonary"></div> {{ 'ADNREPORT.SKILLS.TYPES.TASK' | translate }}</div>
            <hr>

            <div class="score-legend" *ngIf="reportType === 'consultant'">
                nº {{ 'REPORT.CT.ADN.CONSULTANT.SCORE' | translate }}
            </div>
            <div class="level-required-legend" *ngIf="test.adjustment">
              <div><hr><span>&#x25CF;</span></div>
              <div>{{ 'REPORT.CT.ADN.GENERAL.RESULTSCHART.CHART.LEGEND.REQUIRED_LEVEL' | translate }}</div>
            </div>
          </div>

          <div class="chart-legend-bottom body-xxs d-flex justify-content-between">
            <div>
              <svg width="23px" height="24px" viewBox="0 0 23 24">
                <title>excelent</title>
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g transform="translate(-90, -958)" stroke="#BDBDBD">
                        <g transform="translate(90, 958)">
                            <path d="M10.7094306,2.10042771 C11.3164037,1.89810335 12.0005609,1.92733142 12.618034,2.23606798 C13.1018525,2.47797723 13.4941587,2.87028346 13.736068,3.35410197 L22,19.881966 C22.3087366,20.4994391 22.3379646,21.1835963 22.1356403,21.7905694 C21.9333159,22.3975425 21.4994391,22.9273314 20.881966,23.236068 C20.5348274,23.4096373 20.1520448,23.5 19.763932,23.5 L3.23606798,23.5 C2.54571204,23.5 1.92071204,23.220178 1.46830102,22.767767 C1.01589001,22.3153559 0.736067977,21.6903559 0.736067977,21 C0.736067977,20.6118873 0.826430707,20.2291046 1,19.881966 L9.26393202,3.35410197 C9.57266858,2.73662884 10.1024575,2.30275207 10.7094306,2.10042771 Z" id="Triangle" [attr.fill] ="this.colors.tertiaryColor" stroke-linejoin="round"></path>
                            <line x1="7.5" y1="8.5" x2="15.5" y2="8.5" stroke-linecap="square"></line>
                            <line x1="4.5" y1="13.5" x2="18.5" y2="13.5" stroke-linecap="square"></line>
                            <line x1="2.5" y1="18.5" x2="20.5" y2="18.5" stroke-linecap="square"></line>
                        </g>
                    </g>
                </g>
              </svg>
              <div>{{ 'REPORT.CT.ADN.GENERAL.RESULTSCHART.CHART.LEGEND.EXCELENT_DEVELOPMENT' | translate }}.<br><span *ngIf="reportType === 'consultant'">{{ 'REPORT.CT.ADN.GENERAL.RESULTSCHART.CHART.LEGEND.EXCELENT_DEVELOPMENT_SCORES' | translate }}</span></div>
            </div>
            <div>
              <svg width='23px' height='24px' viewBox='0 0 23 24' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'>
                <title>good</title>
                <g  stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
                    <g transform='translate(-155, -958)'>
                        <g transform='translate(155, 958)'>
                            <path d='M13.259413,3.2549141 L21.5,18.5 L21.5,18.5 L1.5,18.5 L9.74058697,3.2549141 C10.2658286,2.28321712 11.4793371,1.92129353 12.4510341,2.44653514 C12.7934075,2.63160185 13.0743463,2.91254068 13.259413,3.2549141 Z' id='Triangle' [attr.fill] ="this.colors.tertiaryColor"></path>
                            <path d='M10.7094306,2.10042771 C11.3164037,1.89810335 12.0005609,1.92733142 12.618034,2.23606798 C13.1018525,2.47797723 13.4941587,2.87028346 13.736068,3.35410197 L22,19.881966 C22.3087366,20.4994391 22.3379646,21.1835963 22.1356403,21.7905694 C21.9333159,22.3975425 21.4994391,22.9273314 20.881966,23.236068 C20.5348274,23.4096373 20.1520448,23.5 19.763932,23.5 L3.23606798,23.5 C2.54571204,23.5 1.92071204,23.220178 1.46830102,22.767767 C1.01589001,22.3153559 0.736067977,21.6903559 0.736067977,21 C0.736067977,20.6118873 0.826430707,20.2291046 1,19.881966 L9.26393202,3.35410197 C9.57266858,2.73662884 10.1024575,2.30275207 10.7094306,2.10042771 Z' id='Triangle' stroke='#BDBDBD' fill-opacity='0' fill='#FFFFFF' stroke-linejoin='round'></path>
                            <line x1='7.5' y1='8.5' x2='15.5' y2='8.5' id='Line' stroke='#BDBDBD' stroke-linecap='square'></line>
                            <line x1='4.5' y1='13.5' x2='18.5' y2='13.5' id='Line' stroke='#BDBDBD' stroke-linecap='square'></line>
                            <line x1='2.5' y1='18.5' x2='20.5' y2='18.5' id='Line' stroke='#BDBDBD' stroke-linecap='square'></line>
                        </g>
                    </g>
                </g>
              </svg>
              <div>{{ 'REPORT.CT.ADN.GENERAL.RESULTSCHART.CHART.LEGEND.GOOD_DEVELOPMENT' | translate }}.<br><span *ngIf="reportType === 'consultant'">{{ 'REPORT.CT.ADN.GENERAL.RESULTSCHART.CHART.LEGEND.GOOD_DEVELOPMENT_SCORES' | translate }}</span></div>
            </div>
            <div>
              <svg width="23px" height="24px" viewBox="0 0 23 24">
                  <title>medium</title>
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g transform="translate(-220, -958)">
                          <g transform="translate(220, 958)">
                              <path d="M13.2755091,3.42419605 L18.5,13.5 L18.5,13.5 L4.5,13.5 L9.72449094,3.42419605 C10.2329432,2.44360947 11.4400478,2.06086902 12.4206343,2.56932132 C12.7869585,2.75926719 13.0855632,3.05787187 13.2755091,3.42419605 Z" id="Triangle" [attr.fill] ="this.colors.tertiaryColor"></path>
                              <path d="M10.7094306,2.10042771 C11.3164037,1.89810335 12.0005609,1.92733142 12.618034,2.23606798 C13.1018525,2.47797723 13.4941587,2.87028346 13.736068,3.35410197 L22,19.881966 C22.3087366,20.4994391 22.3379646,21.1835963 22.1356403,21.7905694 C21.9333159,22.3975425 21.4994391,22.9273314 20.881966,23.236068 C20.5348274,23.4096373 20.1520448,23.5 19.763932,23.5 L3.23606798,23.5 C2.54571204,23.5 1.92071204,23.220178 1.46830102,22.767767 C1.01589001,22.3153559 0.736067977,21.6903559 0.736067977,21 C0.736067977,20.6118873 0.826430707,20.2291046 1,19.881966 L9.26393202,3.35410197 C9.57266858,2.73662884 10.1024575,2.30275207 10.7094306,2.10042771 Z" id="Triangle" stroke="#BDBDBD" fill-opacity="0" fill="#FFFFFF" stroke-linejoin="round"></path>
                              <line x1="7.5" y1="8.5" x2="15.5" y2="8.5" stroke="#BDBDBD" stroke-linecap="square"></line>
                              <line x1="4.5" y1="13.5" x2="18.5" y2="13.5" stroke="#BDBDBD" stroke-linecap="square"></line>
                              <line x1="2.5" y1="18.5" x2="20.5" y2="18.5" stroke="#BDBDBD" stroke-linecap="square"></line>
                          </g>
                      </g>
                  </g>
              </svg>
              <div>{{ 'REPORT.CT.ADN.GENERAL.RESULTSCHART.CHART.LEGEND.MEDIUM_DEVELOPMENT' | translate }}. <br><span *ngIf="reportType === 'consultant'">{{ 'REPORT.CT.ADN.GENERAL.RESULTSCHART.CHART.LEGEND.MEDIUM_DEVELOPMENT_SCORES' | translate }}</span></div>
            </div>
            <div>
              <svg width="23px" height="25px" viewBox="0 0 23 25">
                <title>low</title>
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g transform="translate(-285, -957)">
                        <g id="por" transform="translate(285, 957.9729)">
                            <g transform="translate(0, 0)">
                                <path d="M13.2039888,3.17865258 L16.1943665,8.52706909 L16.1943665,8.52706909 L6.82777405,8.52706909 L9.69802146,3.20528514 C10.2223591,2.23310007 11.4355305,1.870048 12.4077155,2.39438565 C12.7422752,2.57482685 13.0184859,2.84687273 13.2039888,3.17865258 Z" id="Triangle" [attr.fill] ="this.colors.tertiaryColor"></path>
                                <path d="M10.7094306,2.1274968 C11.3164037,1.92517244 12.0005609,1.95440051 12.618034,2.26313707 C13.1018525,2.50504632 13.4941587,2.89735255 13.736068,3.38117106 L22,19.9090351 C22.3087366,20.5265082 22.3379646,21.2106654 22.1356403,21.8176385 C21.9333159,22.4246116 21.4994391,22.9544005 20.881966,23.2631371 C20.5348274,23.4367064 20.1520448,23.5270691 19.763932,23.5270691 L3.23606798,23.5270691 C2.54571204,23.5270691 1.92071204,23.2472471 1.46830102,22.794836 C1.01589001,22.342425 0.736067977,21.717425 0.736067977,21.0270691 C0.736067977,20.6389564 0.826430707,20.2561737 1,19.9090351 L9.26393202,3.38117106 C9.57266858,2.76369794 10.1024575,2.32982116 10.7094306,2.1274968 Z" id="Triangle" stroke="#BDBDBD" fill-opacity="0" fill="#FFFFFF" stroke-linejoin="round"></path>
                                <line x1="7.5" y1="8.52706909" x2="15.5" y2="8.52706909" stroke="#BDBDBD" stroke-linecap="square"></line>
                                <line x1="4.5" y1="13.5270691" x2="18.5" y2="13.5270691" stroke="#BDBDBD" stroke-linecap="square"></line>
                                <line x1="2.5" y1="18.5270691" x2="20.5" y2="18.5270691" stroke="#BDBDBD" stroke-linecap="square"></line>
                            </g>
                        </g>
                    </g>
                </g>
              </svg>
              <div>{{ 'REPORT.CT.ADN.GENERAL.RESULTSCHART.CHART.LEGEND.LOW_DEVELOPMENT' | translate }}.<br><span *ngIf="reportType === 'consultant'">{{ 'REPORT.CT.ADN.GENERAL.RESULTSCHART.CHART.LEGEND.LOW_DEVELOPMENT_SCORES' | translate }}</span></div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="textrarebluelight">
      <span hidden>
        {{ separator }}
      </span>
    </div>

    <!-- Interpretación de resultados (Consultor y Cliente) -->
    <ng-container *ngIf="test && reportType !== 'candidate'">

      <div class="page" *ngIf="reportType !== 'executive'">
        <h1 class="color-tertiary title-xl mar-b-3">{{ 'REPORT.CT.ADN.GENERAL.RESULTS.TITLE' | translate }}</h1>
        <p>{{ 'REPORT.CT.ADN.GENERAL.RESULTS.EXPLANATION.LEVELS.INTRODUCTION' | translate }}</p>
        <div id="resultsTable">
          <!-- tabla de explicación de interpretación de resultados -->
          <table class="results_table results_table_explanation body-xs">
            <tr class="table_header" *ngIf="reportType === 'consultant'">
              <th>{{ 'REPORT.CT.ADN.GENERAL.RESULTS.EXPLANATION.LEVELS.LEVEL' | translate }}</th>
              <td>4</td>
              <td>3</td>
              <td>2</td>
              <td>1</td>
            </tr>
            <tr class="table_header">
              <th>{{ 'REPORT.CT.ADN.GENERAL.RESULTS.EXPLANATION.LEVELS.DEVELOPMENTLEVEL' | translate }}</th>
              <td>{{ 'REPORT.CT.ADN.GENERAL.RESULTSCHART.CHART.LEGEND.EXCELENT_DEVELOPMENT' | translate }}</td>
              <td>{{ 'REPORT.CT.ADN.GENERAL.RESULTSCHART.CHART.LEGEND.GOOD_DEVELOPMENT' | translate }}</td>
              <td>{{ 'REPORT.CT.ADN.GENERAL.RESULTSCHART.CHART.LEGEND.MEDIUM_DEVELOPMENT' | translate }}</td>
              <td>{{ 'REPORT.CT.ADN.GENERAL.RESULTSCHART.CHART.LEGEND.LOW_DEVELOPMENT' | translate }}</td>
            </tr>
            <tr *ngIf="reportType === 'consultant'">
              <th>{{ 'REPORT.CT.ADN.GENERAL.RESULTS.EXPLANATION.LEVELS.SCORES' | translate }}</th>
              <td>{{ 'REPORT.CT.ADN.GENERAL.RESULTS.EXPLANATION.LEVELS.SCORES4' | translate }}</td>
              <td>{{ 'REPORT.CT.ADN.GENERAL.RESULTS.EXPLANATION.LEVELS.SCORES3' | translate }}</td>
              <td>{{ 'REPORT.CT.ADN.GENERAL.RESULTS.EXPLANATION.LEVELS.SCORES2' | translate }}</td>
              <td>{{ 'REPORT.CT.ADN.GENERAL.RESULTS.EXPLANATION.LEVELS.SCORES1' | translate }}</td>
            </tr>
            <tr *ngIf="reportType === 'consultant'">
              <th>{{ 'REPORT.CT.ADN.GENERAL.RESULTS.EXPLANATION.LEVELS.LEVELPERCENTAGE' | translate }}</th>
              <td>30%</td>
              <td>40%</td>
              <td>24%</td>
              <td>6%</td>
            </tr>
            <tr>
              <th>{{ 'REPORT.CT.ADN.GENERAL.RESULTS.EXPLANATION.LEVELS.COMPETENCEPERCENTAGE' | translate }}</th>
              <td>{{ 'REPORT.CT.ADN.GENERAL.RESULTS.EXPLANATION.LEVELS.COMPETENCEPERCENTAGE4' | translate }}</td>
              <td>{{ 'REPORT.CT.ADN.GENERAL.RESULTS.EXPLANATION.LEVELS.COMPETENCEPERCENTAGE3' | translate }}</td>
              <td>{{ 'REPORT.CT.ADN.GENERAL.RESULTS.EXPLANATION.LEVELS.COMPETENCEPERCENTAGE2' | translate }}</td>
              <td>{{ 'REPORT.CT.ADN.GENERAL.RESULTS.EXPLANATION.LEVELS.COMPETENCEPERCENTAGE1' | translate }}</td>
            </tr>
          </table>

          <p class="body-xs mar-b-0">{{ 'REPORT.CT.ADN.GENERAL.RESULTS.EXPLANATION.LEVELS.FOOTER' | translate }}</p>

          <!-- explicaciones de tiemplo empleado y distribución de las respuestas (sólo consultor IP) -->
          <ng-container *ngIf="test.testModelId === 2 && reportType === 'consultant'">
            <p class="mar-t-6 mar-b-0">{{ 'REPORT.CT.ADN.GENERAL.RESULTS.EXPLANATION.TIMESPEND.INTRODUCTION' | translate }}</p>
            <hr id="division" />
            <div>
              <p><span class="color-tertiary"> {{timeSpentRounded}} {{ 'REPORT.CT.ADN.GENERAL.RESULTS.EXPLANATION.TIMESPEND.MINUTES' | translate }}.</span>
                <ng-container *ngIf="timeSpentRounded < 15">
                  {{ 'REPORT.CT.ADN.GENERAL.RESULTS.EXPLANATION.TIMESPEND.LESS' | translate }}
                </ng-container>
                <ng-container *ngIf="timeSpentRounded>= 15 && timeSpentRounded <= 35">
                  {{ 'REPORT.CT.ADN.GENERAL.RESULTS.EXPLANATION.TIMESPEND.OPTIMAL' | translate }}
                </ng-container>
                <ng-container *ngIf="timeSpentRounded> 35">
                  {{ 'REPORT.CT.ADN.GENERAL.RESULTS.EXPLANATION.TIMESPEND.GREATER' | translate }}
                </ng-container>
              </p>
            </div>

            <p class="mar-t-2 mar-b-4">{{ 'REPORT.CT.ADN.GENERAL.RESULTS.EXPLANATION.ANSWERDISTRIBUTION.INTRODUCTION' | translate }}</p>
            <div class="text-center text-lowercase">
              <div class="d-inline-block mar-x-1 pad-1 rounded bg-color-tertiary color-light w-25">
                <span>{{ 'REPORT.CT.ADN.GENERAL.RESULTS.EXPLANATION.ANSWERDISTRIBUTION.ISBETTER' | translate }}</span> <br>
                <span class="color-primary">{{ test.result.answerExtremeCounter }}</span>
              </div>
              <div class="d-inline-block mar-x-1 pad-1 rounded bg-color-nonary color-primary w-25">
                <span>{{ 'REPORT.CT.ADN.GENERAL.RESULTS.EXPLANATION.ANSWERDISTRIBUTION.SLIGHTLYBETTER' | translate }}</span> <br>
                <span class="color-septenary">{{ test.result.answerBitCounter }}</span>
              </div>
              <div class="d-inline-block mar-x-1 pad-1 rounded bg-color-tertiary color-light w-25">
                <span>{{ 'REPORT.CT.ADN.GENERAL.RESULTS.EXPLANATION.ANSWERDISTRIBUTION.BOTHEQUALLY' | translate }}</span> <br>
                <span class="color-primary">{{ test.result.answerSameCounter }}</span>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- puntuationes por skill -->
      <div class="page" [class]="reportType == 'executive' ? 'executiveReportStyle': ''">
        <!-- sin ajuste -->
        <ng-container *ngIf="!test.adjustment">
          <p *ngIf="reportType !== 'executive'">{{ 'REPORT.CT.ADN.' + reportType.toUpperCase() + '.SCORES.NOTADJUSTMENT.INTRODUCTION' | translate }}</p>
          <p *ngIf="reportType === 'executive'" innerHTML="{{ 'REPORT.CT.ADN.' + reportType.toUpperCase() + '.INTRODUCTION' | translate }}"></p>
          <hr id="division" />
          <div class="row mar-t-4">
            <div class="skill mar-b-4 " [class]="reportType !== 'executive' ? 'col-6': 'col-12'" *ngFor="let adnScore of scoresParse, let i = index">
              <div [class]="(this.reportType === 'client' || reportType == 'executive') ?'title-s mar-b-2':'title-s'">{{('ADNREPORT.SKILLS.' + adnScore.questionGroupAbbreviation + '.NAME') | translate }}</div>
              <ct-level-bar [hide]="true" [adnSkill]="enrichedSkill(adnScore)" [colors]="colors"></ct-level-bar>
              <ul class="mar-t-2">
                <li>{{('ADNREPORT.SKILLS.' + adnScore.questionGroupAbbreviation + '.LEVEL.' + adnScore.rangeId + '.OTHER.' + testModel + '.' + textVariationParagraph1 ) | translate:{ candidateName: (test.candidate?.name ? (test.candidate | initials) : test.candidate.randstadCandidate) } }}</li>
                <li>{{('ADNREPORT.SKILLS.' + adnScore.questionGroupAbbreviation + '.LEVEL.' + adnScore.rangeId + '.OTHER.' + testModel + '.' + textVariationParagraph2 ) | translate:{ candidateName: (test.candidate?.name ? (test.candidate | initials) : test.candidate.randstadCandidate) } }}</li>
              </ul>
              <!-- En el pdf solo pone 2 competencias por página y que no pone una página en blanco al final -->
              <div [class]="(i%2 != 0 && i < scoresParse.length-1) ? 'page p-0':''"></div>
              <div class="textrarebluelight" *ngIf="(i%2 != 0 && i < scoresParse.length-1)">
                <span hidden>
                  {{ separator }}
                </span>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- con ajuste -->
        <ng-container *ngIf="test.adjustment">
          <p *ngIf="reportType !== 'executive'">{{ 'REPORT.CT.ADN.' + reportType.toUpperCase() + '.SCORES.ADJUSTMENT.INTRODUCTION' | translate }}</p>
          <p *ngIf="reportType === 'executive'" innerHTML="{{ 'REPORT.CT.ADN.' + reportType.toUpperCase() + '.INTRODUCTION' | translate }}"></p>
          <hr id="division" />

          <ng-container *ngIf="reportType === 'consultant'">
            <div class="mar-b-1 d-flex align-items-center">
              <div class="marker skillValueAdjust">
                <span class="score ">n</span>
              </div>
              <span class="">{{ 'REPORT.CT.ADN.CONSULTANT.SCORES.ADJUSTMENT.MARKER.ADJUST' | translate }}</span>
            </div>
            <div class="mar-b-1 d-flex align-items-center">
              <div class="marker skillValueNoAdjust">
                <span class="score">n</span>
              </div>
              <span>{{ 'REPORT.CT.ADN.CONSULTANT.SCORES.ADJUSTMENT.MARKER.NOADJUST' | translate }}</span>
            </div>
            <div class="mar-b-1 d-flex align-items-center">
              <div class="marker idealProfileMinValue">
                <span class="score">n</span>
              </div>
              <span>{{ 'REPORT.CT.ADN.CONSULTANT.SCORES.ADJUSTMENT.MARKER.IDEALPROFILE' | translate }}</span>
            </div>
            <div class="mar-b-1 d-flex align-items-center">
              <div class="marker skillValueNoIdeal">
                <span class="score">n</span>
              </div>
              <span>{{ 'REPORT.CT.ADN.CONSULTANT.SCORES.ADJUSTMENT.MARKER.NOIDEALPROFILE' | translate }}</span>
            </div>
          </ng-container>

            <div class="row mar-t-4">
              <div class="skill mar-b-4" [class]="reportType !== 'executive' ? 'col-6': 'col-12'" *ngFor="let adnScore of scoresParse, let i = index">
                <div [class]="this.reportType === 'client'?'title-s mar-b-2':'title-s'">{{('ADNREPORT.SKILLS.' + adnScore.questionGroupAbbreviation + '.NAME') | translate }}</div>
                <ct-level-bar [hide]="true" [adnSkill]="enrichedSkill(adnScore)" [colors]="colors"></ct-level-bar>
                <ul class="mar-t-2" [style]="reportType === 'executive' ? 'padding-inline-start: 0':''">
                  <li *ngIf="reportType !== 'executive'">{{('ADNREPORT.SKILLS.' + adnScore.questionGroupAbbreviation + '.LEVEL.' + adnScore.rangeId + '.OTHER.' + testModel + '.' + textVariationParagraph1 ) | translate:{ candidateName: (test.candidate?.name ? (test.candidate | initials) : test.candidate.randstadCandidate) } }}</li>
                  <li [style]="reportType === 'executive' ? 'list-style: none' :''">{{('ADNREPORT.SKILLS.' + adnScore.questionGroupAbbreviation + '.LEVEL.' + adnScore.rangeId + '.OTHER.' + testModel + '.' + textVariationParagraph2 ) | translate:{ candidateName: (test.candidate?.name ? (test.candidate | initials) : test.candidate.randstadCandidate) } }}</li>
                </ul>
                <!-- En el pdf solo pone 2 competencias por página y que no pone una página en blanco al final -->
                <div [class]="(i%2 != 0 && i < scoresParse.length-1) ? 'page p-0':''"></div>
              </div>
            </div>

        </ng-container>

        <ng-container *ngIf="reportType === 'executive'">
          <a class="btn btn-outline-primary pad-3" style="font-size: 14px;" [href]="AppConfig.settings.HOME + '/#/report/ct/' + test.clientReportToken" target="_blank">{{ 'REPORT.CT.ADN.EXECUTIVE.FULLREPORT' | translate }}</a>
        </ng-container>

      </div>

      <!-- Guión de entrevista (sólo consultor) -->
      <ng-container *ngIf="reportType === 'consultant' && scoresParseInterviewFiltered.length">
        <div class="page">
          <h1 class="color-tertiary title-xl mar-b-3">{{ 'REPORT.CT.ADN.CONSULTANT.INTERVIEWGUIDELINES.TITLE' | translate }}</h1>
          <p *ngIf="!test.adjustment">{{ 'REPORT.CT.ADN.CONSULTANT.INTERVIEWGUIDELINES.NOTADJUSTMENT.INTRODUCTION' | translate:{ initials: (test.candidate?.name ? (test.candidate | initials) : test.candidate.randstadCandidate) } }}</p>
          <p *ngIf="test.adjustment">{{ 'REPORT.CT.ADN.CONSULTANT.INTERVIEWGUIDELINES.ADJUSTMENT.INTRODUCTION' | translate:{ initials: (test.candidate?.name ? (test.candidate | initials) : test.candidate.randstadCandidate) } }}</p>
          <hr id="division" />

          <div class="row mar-t-4">
            <div class="skill mar-b-4 col-6" *ngFor="let adnScore of scoresParseInterviewFiltered, let i = index">
              <div class="title-s">{{('ADNREPORT.SKILLS.' + adnScore.questionGroupAbbreviation + '.NAME') | translate }}</div>
              <ct-level-bar [value]="test.result.informationDigitalLiteracy * 10" [hide]="true" [adnSkill]="enrichedSkill(adnScore, true)" [colors]="colors"></ct-level-bar>
              <ul class="mar-t-2">
                <li>{{('ADNREPORT.SKILLS.' + adnScore.questionGroupAbbreviation + '.LEVEL.' + adnScore.rangeId + '.OTHER.INTERVIEW.VARIATION_1' ) | translate:{ candidateName: (test.candidate?.name ? (test.candidate | initials) : test.candidate.randstadCandidate) } }}</li>
                <li>{{('ADNREPORT.SKILLS.' + adnScore.questionGroupAbbreviation + '.LEVEL.' + adnScore.rangeId + '.OTHER.INTERVIEW.VARIATION_2' ) | translate:{ candidateName: (test.candidate?.name ? (test.candidate | initials) : test.candidate.randstadCandidate) } }}</li>
                <li>{{('ADNREPORT.SKILLS.' + adnScore.questionGroupAbbreviation + '.LEVEL.' + adnScore.rangeId + '.OTHER.INTERVIEW.VARIATION_3' ) | translate:{ candidateName: (test.candidate?.name ? (test.candidate | initials) : test.candidate.randstadCandidate) } }}</li>
                <li>{{('ADNREPORT.SKILLS.' + adnScore.questionGroupAbbreviation + '.LEVEL.' + adnScore.rangeId + '.OTHER.INTERVIEW.VARIATION_4' ) | translate:{ candidateName: (test.candidate?.name ? (test.candidate | initials) : test.candidate.randstadCandidate) } }}</li>
              </ul>
              <!-- En el pdf solo pone 2 competencias por página y que no pone una página en blanco al final -->
              <div [class]="(i%2 != 0 && i < scoresParseInterviewFiltered.length-1) ? 'page p-0':''"></div>
            </div>
          </div>
        </div>
      </ng-container>

    </ng-container>

    <!-- Interpretación de resultados (Candidato) -->
    <ng-container *ngIf="test && reportType === 'candidate'">

      <!-- Fortalezas (Candidato) -->
      <div class="page">
        <div id="strengths">
          <h1 class="color-tertiary title-xl mar-b-3">{{ 'COMMON.STRENGTHS' | translate }}.</h1>
          <p>{{ 'REPORT.CT.ADN.CANDIDATE.STRENGTHSTEXT' | translate }}</p>
          <hr id="division" />
          <div class="row mar-t-4">
            <div class="skill mar-b-4 col-6" *ngFor="let adnScore of scoresParseStrenghtsFiltered, let i = index">
              <div class="title-s">{{('ADNREPORT.SKILLS.' + adnScore.questionGroupAbbreviation + '.NAME') | translate }}</div>
              <ul class="mar-t-2">
                <li>{{('ADNREPORT.SKILLS.' + adnScore.questionGroupAbbreviation + '.LEVEL.' + adnScore.rangeId + '.CANDIDATE.' + testModel + '.' + textVariationParagraph1 ) | translate:{ candidateName: (test.candidate?.name ? (test.candidate | initials) : test.candidate.randstadCandidate) } }}</li>
                <li>{{('ADNREPORT.SKILLS.' + adnScore.questionGroupAbbreviation + '.LEVEL.' + adnScore.rangeId + '.CANDIDATE.' + testModel + '.' + textVariationParagraph2 ) | translate:{ candidateName: (test.candidate?.name ? (test.candidate | initials) : test.candidate.randstadCandidate) } }}</li>
              </ul>
              <!-- En el pdf solo pone 2 competencias por página y que no pone una página en blanco al final -->
              <div [class]="(i%2 != 0 && i < scoresParseStrenghtsFiltered.length-1) ? 'page p-0':''"></div>
            </div>
            <div class="col-12" *ngIf="scoresParseStrenghtsFiltered.length == 0">
              <p>{{ 'REPORT.CT.ADN.CANDIDATE.NOSTRENGTHSTEXT' | translate }}</p>
            </div>
          </div>

        </div>
      </div>

      <!-- Areas de mejora (Candidato) -->
      <div class="page">
        <div id="tips">
          <h1 class="color-tertiary title-xl mar-b-3">{{ 'COMMON.TIPS' | translate }}</h1>
          <p>{{ 'REPORT.CT.ADN.CANDIDATE.TIPSTEXT' | translate }}</p>
          <hr id="division" />
          <div class="row mar-t-4">
            <div class="skill mar-b-4 col-6" *ngFor="let adnScore of scoresParseTipsFiltered, let i = index">
              <div class="title-s">{{('ADNREPORT.SKILLS.' + adnScore.questionGroupAbbreviation + '.NAME') | translate }}</div>
              <ul class="mar-t-2">
                <li *ngFor="let skillTipsVariation of textTipsVariations[adnScore.questionGroupId - 12]"> {{('ADNREPORT.SKILLS.' + adnScore.questionGroupAbbreviation + '.LEVEL.1.CANDIDATE.VARIATION_' + skillTipsVariation ) | translate:{ candidateName: (test.candidate?.name ? (test.candidate | initials) : test.candidate.randstadCandidate) } }}</li>
              </ul>
              <!-- En el pdf solo pone 2 competencias por página y que no pone una página en blanco al final -->
              <div [class]="(i%2 != 0 && i < scoresParseTipsFiltered.length-1) ? 'page p-0':''"></div>
            </div>
            <div class="col-12" *ngIf="scoresParseTipsFiltered.length == 0">
              <p>{{ 'REPORT.CT.ADN.CANDIDATE.NOTIPSTEXT' | translate }}</p>
            </div>
          </div>

          <hr>
          <p id="closure" [innerHTML]="'REPORT.CT.ADN.GENERAL.CLOSURE' | translate:{ name: (sanitizedCandidateName ? (sanitizedCandidateName | titlecase) : ('COMMON.GREAT' | translate) | titlecase) }"></p>
        </div>

      </div>

    </ng-container>

    <!-- Pagina final -->
    <ct-last-page-report [colors]="colors" *ngIf="reportType != 'executive'" [test]="test"></ct-last-page-report>

  </div>
</div>

<button class="btn btn-primary pdf_button" (click)="bowserprint()">{{ 'COMMON.GENERATEPDF' | translate }}</button>
<button class="btn btn-primary" id="bowser" (click)="print()" hidden>{{ 'COMMON.GENERATEPDF' | translate }}</button>

<pre id="base64" hidden></pre>
